import { render, staticRenderFns } from "./AddFaqDialog.vue?vue&type=template&id=c0bda854&scoped=true&"
import script from "./AddFaqDialog.vue?vue&type=script&lang=js&"
export * from "./AddFaqDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddFaqDialog.vue?vue&type=style&index=0&id=c0bda854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bda854",
  null
  
)

export default component.exports